module.exports = __webpack_public_path__ + "img/dreams_jp.6c1c9a2.jpg";